import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

export type SkeletonTone = 'brand' | 'neutral'

const skeletonTones: Record<SkeletonTone, string> = {
  brand: 'bg-accentSecondary',
  neutral: 'bg-muted-foreground/20',
}

export type SkeletonProps = ComponentProps<'div'> & {
  tone?: SkeletonTone
}

function Skeleton({ className, tone = 'brand', ...props }: SkeletonProps) {
  return (
    <div
      data-slot="skeleton"
      data-tone={tone}
      className={cn(
        'animate-pulse rounded-md',
        skeletonTones[tone] ?? skeletonTones.brand,
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
